import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

const PageNavigation = (props) => {
  return (
    <Wrapper>
      <NavLink to="/">Home</NavLink>/{props.title}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  height: 3rem;
  background-color: ${({ theme }) => theme.colors.bg};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 2.2rem;
  padding-left: 1rem;

  a {
    text-decoration: none;
    color:  ${({ theme }) => theme.colors.bgd};;
    font-size: 2.5rem;
    }
`;

export default PageNavigation;